// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__23dPL","inputDescription":"styles_inputDescription__3kdgO"};